const IconReplay = ({ className }) => {
    return (
        <svg viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path d='m32 3a29 29 0 1 0 29 29 29.033 29.033 0 0 0 -29-29zm0 51a22 22 0 1 1 17.428-35.428l2.572-2.572 1 10-9-2 2.571-2.571a18 18 0 1 0 3.429 10.571h4a22 22 0 0 1 -22 22zm9-22-14 10v-20z'></path>
        </svg>
    );
};

export default IconReplay;
